"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var _icons = require("../../../icons");

var _accordion = require("./accordion");

var styles = _interopRequireWildcard(require("./expandable.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Expandable = function Expandable(_ref) {
  var children = _ref.children,
      id = _ref.id,
      label = _ref.label,
      isOpened = _ref.isOpened,
      autoClose = _ref.autoClose,
      onClick = _ref.onClick;

  var _useContext = (0, _react.useContext)(_accordion.AccordionContext),
      openedId = _useContext.openedId,
      toggleOpenedId = _useContext.toggleOpenedId;

  var _useState = (0, _react.useState)(isOpened),
      _useState2 = _slicedToArray(_useState, 2),
      currentIsOpened = _useState2[0],
      setCurrentIsOpened = _useState2[1];

  var wrapperclassName = (0, _react.useMemo)(function () {
    return [styles.wrapper, currentIsOpened ? styles.active : ""].join(" ");
  }, [currentIsOpened]);
  var clickHandler = (0, _react.useCallback)(function () {
    setCurrentIsOpened(function (oldIsOpened) {
      var newIsOpened = !oldIsOpened;
      onClick(newIsOpened);
      return newIsOpened;
    });
    toggleOpenedId(id);
  }, [onClick, toggleOpenedId, id]);
  (0, _react.useEffect)(function () {
    setCurrentIsOpened(isOpened);
  }, [isOpened]);
  (0, _react.useEffect)(function () {
    if (!autoClose) {
      return;
    }

    setCurrentIsOpened(openedId === id);
  }, [autoClose, openedId, id]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperclassName
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: styles.button,
    onClick: clickHandler
  }, /*#__PURE__*/_react.default.createElement(_.Text, {
    size: "lg",
    weight: "bold",
    className: styles.label
  }, label), /*#__PURE__*/_react.default.createElement(_icons.ArrowIcon, {
    className: styles.icon
  })), currentIsOpened && /*#__PURE__*/_react.default.createElement("div", {
    className: styles.content
  }, children));
};

exports.Expandable = Expandable;
Expandable.defaultProps = {
  id: null,
  label: null,
  isOpened: false,
  autoClose: false,
  onClick: function onClick() {}
};
Expandable.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  isOpened: _propTypes.default.bool,
  autoClose: _propTypes.default.bool,
  onClick: _propTypes.default.func
};